<template>
  <div class="recipe">
    <Loading v-show="loading"></Loading>
    <div class="content" v-for="r of recipe"  :key="r">
      <div class="header">
        <p id="title">{{ r.name }}</p>
        <a id="close" v-on:click="back()"><img  src="../../assets/left.png" alt=""></a>
        <button class="favorite" v-on:click="unfavorite()" v-show="r.isFavorite"><img  src="../../assets/fav.png" alt=""></button>
        <button class="favorite" v-on:click="favorite()" v-show="r.isUnFavorite"><img  src="../../assets/unfav.png" alt=""></button>
      </div>
      <div class="first">
        <div class="flexbox">
          <section class="main">
            <img v-bind:src="r.thumbnail">
            <p>{{ r.time }}min | {{ r.kcal }}Kcal</p>
            <table>
              <tr>
                <th>Protein</th>
                <th>Fat</th>
                <th>Carbs</th>
              </tr>
              <tr>
                <td>{{ r.protein }}g</td>
                <td>{{ r.fat }}g</td>
                <td>{{ r.carbs }}g</td>
              </tr>
            </table>
          </section>
          <section class="side">
            <p>+α</p>
            <p>{{ r.recommend }}</p>
          </section>
        </div>
      </div>
      <div class="bar">
        <table>
          <tr>
            <th class="left">INGREDIENTS</th>
            <th class="right">{{ r.ingredientAmount }} items</th>
          </tr>
        </table>
      </div>
      <div class="recipe-content">
        <table v-show="isRecipeOpen">
          <tr>
            <td class="maintitle"></td>
            <td class="maintitle"></td>
            <td class="subtitle">Calories</td>
            <td class="subtitle">P</td>
            <td class="subtitle">F</td>
            <td class="subtitle">C</td>
          </tr>
          <tr v-for="ingredient of r.ingredients"  :key="ingredient">
            <td class="maintitle">{{ ingredient.name }}</td>
            <td class="maintitle">{{ ingredient.amount }}</td>
            <td class="subtitle">{{ ingredient.calory }}Kcal</td>
            <td class="subtitle">{{ ingredient.protein }}g</td>
            <td class="subtitle">{{ ingredient.fat }}g</td>
            <td class="subtitle">{{ ingredient.carbs }}g</td>
          </tr>
        </table>
        <table v-show="isRecipeClose">
          <tr>
            <td class="maintitle"></td>
            <td class="maintitle"></td>
            <td class="subtitle">Calories</td>
            <td class="subtitle">P</td>
            <td class="subtitle">F</td>
            <td class="subtitle">C</td>
          </tr>
          <tr v-for="ingredient of r.topIngredients"  :key="ingredient">
            <td class="maintitle">{{ ingredient.name }}</td>
            <td class="maintitle">{{ ingredient.amount }}</td>
            <td class="subtitle">{{ ingredient.calory }}Kcal</td>
            <td class="subtitle">{{ ingredient.protein }}g</td>
            <td class="subtitle">{{ ingredient.fat }}g</td>
            <td class="subtitle">{{ ingredient.carbs }}g</td>
          </tr>
          <tr><td colspan="6"><button class="openButton" v-on:click="openRecipe()"><img  src="../../assets/bottom.png" alt=""></button></td></tr>
          </table>
      </div>
      <div class="bar">
        <table>
          <tr>
            <th class="left">PREPARATION</th>
            <th class="right">{{ r.preparationAmount }} steps</th>
          </tr>
        </table>
      </div>
      <div class="preparation-content">
        <table v-show="isPreparationOpen">
          <tr v-for="(preparation, index) in r.preparation">
            <td class="process">{{ index+1 }}、{{ preparation }}</td>
          </tr>
        </table>
        <table v-show="isPreparationClose">
          <tr v-for="(preparation, index) in r.topPreparation">
            <td class="process">{{ index+1 }}、{{ preparation }}</td>
          </tr>
          <tr><td><button class="openButton" v-on:click="openPreparation()"><img  src="../../assets/bottom.png" alt=""></button></td></tr>
          </table>
      </div>
    </div>
  </div>
</template>
<style scoped>
.recipe .header {
  position: relative;
  height: 100px;
  width: 60%;
  margin:0 auto;
  
}
.recipe .favorite {
  position: absolute;
  right: 8px;
  background:white;
  border:0;
  width: 36px;
  margin-top: 32px;
}
.openButton{
  background: white;
  border:0;
  position: relative;
}
.recipe .openButton img{
  width: 18px;
  position: absolute;
  background: white;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
}
.recipe .favorite img{
  width: 24px;
  background:white;
}
.recipe #title{
  display: inline-block;
  margin:0 auto;
  line-height: 100px;

}
.recipe #close {
  position: absolute;
  left: 8px;
}
.recipe #close img{
  width: 36px;
  margin-top: 32px;
}
.recipe .bar{
  background: #CCCCCC;
  margin-top: 36px;
}
.recipe .bar table{
  width: 60%;
  margin: 0 auto;
}
.recipe .bar .left{
  text-align: left;
  width: 50%;
}
.recipe .bar .right{
  text-align: right;
  width: 50%;
}
.recipe .recipe-content table{
  margin: 16px auto;
  width: 50%;
}
.recipe .preparation-content table{
  margin: 16px auto;
  width: 50%;
}
.recipe .preparation-content .process{
  text-align: left;
}
.recipe .recipe-content .maintitle{
  width: 30%;
  text-align: left;
}
.recipe .recipe-content .subtitle{
  text-align: center;
  width: 10%;
}
.main {
  width: 40%;
  padding:5%;
}
.main img{
  height: 200px;
  width: 100%;
  object-fit: cover;
  border-radius: 20px;
}
.main table{
  width: 100%;
}
.side {
  padding:5%;
  width: 60%;
}
.side p{
  text-align: left;
}
.main,
.side {
}
 
/* Responsive */
@media ( min-width : 600px ){
    .flexbox {
      display: -webkit-flex;
      display: flex;
      margin:0 auto;
      width: 60%;
    }
}
@media ( max-width : 780px ){
   .recipe .header {
    width: 100%; 
}
.main img {
    border-radius: 0px;
    height: auto;
}
.main{
  width: 100%;
  padding: 0%;
  position: relative;
}
.side {
     width: 80%;
    padding-left: 10%;
}
.main p{
  position: absolute;
    bottom:-25%;
    left: 0px;
    width: 50%;
}
.main table {
    position: absolute;
    bottom:-25%;
    right: 0px;
    width: 50%;
}
.side {
    margin-top: 10%;
}
.recipe .bar table {
    width: 90%;
}
.recipe .recipe-content table {
    margin: 16px auto;
    width: 90%;
}
.recipe .preparation-content table {
    margin: 16px auto;
    width: 90%;
}
.recipe .recipe-content .subtitle{
   font-size: 12px;
}
}
</style>
<script>
import $ from 'jquery'
import Loading from '../common/Loading'
import firebase from 'firebase'
export default {
  name: 'Recipe',
  components: {
    Loading
  },
  data () {
    return {
      userId: null,
      recipeId: null,
      db: null,
      loading: false,
      recipe: [],
      isRecipeOpen: false,
      isRecipeClose: true,
      isPreparationOpen: false,
      isPreparationClose: true,
      startDate: null,
      endDate: null

    }
  },
  methods: {
    back: function () {
      // ユーザーIDとクエリー時刻
      console.log('dqwhdgqwhdgqwdqw')
      console.log(this.startDate)
      console.log(this.endDate)
      console.log('dqwhdgqwhdgqwdqw')
      location.href = '/today?startYear=' + this.startDate.getFullYear() + '&startMonth=' + this.startDate.getMonth() + '&startDate=' + this.startDate.getDate() + '&endYear=' + this.endDate.getFullYear() + '&endMonth=' + this.endDate.getMonth() +'&endDate=' + this.endDate.getDate() + '&userId=' + this.userId
    },
    getRecipe: function () {
      console.log(this.recipeId)
      let self = this
      self.loading = true
      this.recipe = []
      var docRef = this.db.collection('recipes').doc(this.recipeId)
      docRef.get().then(function (doc) {
        if (doc.exists) {
          var hash = {}
          hash['name'] = doc.get('name')
          hash['thumbnail'] = null
          hash['kcal'] = doc.get('kcal')
          hash['time'] = doc.get('time')
          hash['protein'] = doc.get('protein')
          hash['fat'] = doc.get('fat')
          hash['carbs'] = doc.get('carbs')
          hash['recommend'] = doc.get('recommend')
          if (doc.get('fav').includes(self.userId)) {
            hash['isFavorite'] = true
            hash['isUnFavorite'] = false
          } else {
            hash['isFavorite'] = false
            hash['isUnFavorite'] = true
          }
          hash['ingredients'] = doc.get('ingredients')
          hash['topIngredients'] = doc.get('ingredients').slice(0, 2)
          hash['ingredientAmount'] = doc.get('ingredients').length

          hash['preparation'] = doc.get('preparation')
          hash['topPreparation'] = doc.get('preparation').slice(0, 2)
          hash['preparationAmount'] = doc.get('preparation').length

          self.recipe.push(hash)
          self.getStorageURL(doc.get('thumbnail'))
        } else {
          alert('不正なアクセスの可能性があります。再度ログインし直してください。')
          self.loading = false
          location.href = '/'
        }
      }).catch(function () {
        alert('サーバー とのアクセスに失敗しました。再度本日のレシピページから選択をお願いいたします。')
        self.loading = false
        location.href = '/today'
      })
    },
    getStorageURL: function (path) {
      let self = this
      var ref = firebase.storage().ref().child(path)
        ref.getDownloadURL().then((url) => {
          console.log(url)
          self.recipe[0].thumbnail = url
          self.loading = false
          
      });

    },
    openRecipe: function () {
      this.isRecipeClose = false
      this.isRecipeOpen = true
    },
    openPreparation: function () {
      this.isPreparationClose = false
      this.isPreparationOpen = true
    },
    favorite: function () {
      let self = this
      const docRef = this.db.collection('recipes').doc(this.recipeId)
        docRef.update({
          fav: firebase.firestore.FieldValue.arrayUnion(this.userId)
          }).then(function () {
            
            const useDocRef = self.db.collection('users').doc(self.userId)
            useDocRef.update({
                recipes: firebase.firestore.FieldValue.arrayUnion(self.recipeId)
                }).then(function () {
                  // 黄色にするだけ
                  self.recipe[0].isFavorite = true
                  self.recipe[0].isUnFavorite = false
                  

              }).catch(function () {
                alert('お気に入りの登録に失敗しました。再度、実行してください。')
                self.loading = false
              })
            

        }).catch(function () {
          alert('お気に入りの登録に失敗しました。再度、実行してください。')
          self.loading = false
        })

    },
    unfavorite: function () {
      let self = this
      const docRef = this.db.collection('recipes').doc(this.recipeId)
        docRef.update({
          fav: firebase.firestore.FieldValue.arrayRemove(this.userId)
          }).then(function () {
            

            const useDocRef = self.db.collection('users').doc(self.userId)
            useDocRef.update({
                recipes: firebase.firestore.FieldValue.arrayRemove(self.recipeId)
                }).then(function () {
                  
                  // グレー色にするだけ
                  self.recipe[0].isFavorite = false
                  self.recipe[0].isUnFavorite = true
                  

              }).catch(function () {
                alert('お気に入りの登録に失敗しました。再度、実行してください。')
                self.loading = false
              })

        }).catch(function () {
          alert('プロフィールの更新に失敗しました。再度、実行してください。')
          self.loading = false
          self.isUpdateModal = false
        })
    }
  },
  created: function () {
    // Planを取得
    let self = this
    this.db = firebase.firestore()
    firebase.auth().languageCode = 'jp'
    var url = location.search.substring(1)
    var parameters = url.split('&')
    var result = Object()
    for (var i = 0; i < parameters.length; i++) {
      var element = parameters[i].split('=')
      var paramName = decodeURIComponent(element[0])
      var paramValue = decodeURIComponent(element[1])
      result[paramName] = decodeURIComponent(paramValue)
    }
    this.userId = result['userId']
    this.recipeId = result['recipeId']
    var startYear = parseInt(result['startYear'], 10)
    var startMonth = parseInt(result['startMonth'], 10)
    var startDate = parseInt(result['startDate'], 10)
    this.startDate = new Date(startYear, startMonth, startDate, 0, 0, 0)
    var endYear = parseInt(result['endYear'], 10)
    var endMonth = parseInt(result['endMonth'], 10)
    var endDate = parseInt(result['endDate'], 10)
    this.endDate = new Date(endYear, endMonth, endDate, 0, 0, 0)
    console.log('受け取ったもの')
    console.log(this.startDate)
    console.log(this.endDate)
    console.log('cefeqffqwfwq')
    if (!this.userId) {
      alert('ユーザーが存在しません、。再度ログインしなおしてください。')
      location.href='/'
    } else {
      this.getRecipe()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/recipe/Recipe.vue